import { PanelRow, PanelCell, Grid, Cell, Icon, Field, Button } from '@teamsnap/teamsnap-ui';
import * as React from 'react';
import './org-legacy-uuid-section.scss';
import TournamentOrgIdSearchForm from './tournament-org-id-search-form';

export type TournamentOrg = {
  id: number,
  name: string
}
export interface Props {
  currentTournamentOrg?: TournamentOrg;
  onPopulate?: (data) => void;
  setTournamentOrgId: React.Dispatch<React.SetStateAction<boolean>>;
}

const OrgEditTournamentOrgId: React.FunctionComponent<Props> = ({
  currentTournamentOrg,
  setTournamentOrgId,
}) => {
  const [tournamentOrg, setTournamentOrg] = React.useState(null);
  const [tournamentCheck, setTournamentCheck] = React.useState<boolean>(false);

  const populateTournamentOrgId = (tournamentOrg) => {
    setTournamentOrgId(tournamentOrg.id);
    setTournamentCheck(true);
  };

  return (
    <PanelRow isWithCells={true} mods="Panel-row--header">
      <PanelCell mods="Panel-cell--header u-size3of12 u-flex">
        <h4>Tournament Org</h4>
      </PanelCell>
      <PanelCell mods="u-size9of12">
        <Grid isWithGutter={true}>
          <Cell mods="u-size12of12 u-colorWarning">
            {!currentTournamentOrg && (
              <div className="u-spaceBottomMd">
                If this Club & League organization also has a TeamSnap Tournaments [TST] organization,
                you can connect the accounts by entering the TST ID in the field below.
                This will display any events created in the TST org in the Org Calendar view
              </div>
            )}
          </Cell>
        </Grid>
        <Grid isWithGutter={true}>
          <Cell mods="u-size12of12">
            {currentTournamentOrg ? (
              <>
                <button
                  key={currentTournamentOrg.id}
                  type="button"
                  disabled
                  className="org-uuid-button u-padSidesMd u-padEndsSm u-spaceTopMd u-border u-borderRadiusMd u-borderColorDefault u-textLeft"
                >
                  <div className="u-spaceXs u-block u-fontSizeSm">{currentTournamentOrg.name}</div>
                  <div className="u-spaceXs u-block u-fontSizeSm">{currentTournamentOrg.id}</div>
                </button>
              </>
            ) : (
              <TournamentOrgIdSearchForm setTournamentOrg={setTournamentOrg} isDisabled={false} />
            )}

            {tournamentOrg && (
              <>
                <button
                  key={tournamentOrg.id}
                  onClick={() => populateTournamentOrgId(tournamentOrg)}
                  type="button"
                  className="org-uuid-button u-padSidesMd u-padEndsSm u-spaceTopMd u-border u-borderRadiusMd u-borderColorDefault u-textLeft"
                >
                  <span className="u-block u-fontSizeLg">{tournamentOrg.name}</span>
                  <span className="u-spaceXs u-block u-fontSizeSm">{tournamentOrg.id}</span>
                  {!tournamentCheck && (
                    <p className="u-textCenter u-fontSizeSm u-spaceTopMd u-colorWarning">
                      Click to use this TST Data &rarr;
                    </p>
                  )}
                </button>
              </>
            )}
          </Cell>
        </Grid>
      </PanelCell>
    </PanelRow>
  );
};

export default OrgEditTournamentOrgId;
